import React, { Component, Fragment } from "react";
import { push } from "connected-react-router";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Logout from "../views/auth/Logout";
import { images } from "../helpers/images";
import LogoutConfirmationModal from "./modals/LogoutConfirmationModal";
import AdminLogoutConfirmationModal from "./modals/AdminLogoutConfirmationModal";

class AdminNavbar extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      showModal: false,
    };
  }

  onShowModal = () => {
    this.setState({ showModal: true });
  };

  onCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { showModal } = this.state;

    return (
      <Fragment>
        <div id="sidebar" className="cell small-12 medium-2">
          <div id="logo" className="">
            <img src={images.logo} />
            <p id="logodesc">
              SAQ Generator
              <br />
              BETA
            </p>
          </div>
          <ul className="vertical menu sidebar-menu">
            <li>
              <Link to="/control-panel" className="current">
                <span className="menu-icn dashboard"></span>Dashboard
              </Link>
            </li>
            <li>
              <Link to="/control-panel/users">
                <span className="menu-icn user"></span> Users
              </Link>
            </li>
            {/* 
            <li>
              <Link to="/admin/users">
                <span className="menu-icn settings"></span> Settings
              </Link>
            </li> */}
            <li>
              <a onClick={() => this.onShowModal()}>
                <span className="menu-icn logout"></span> Logout
              </a>
            </li>
          </ul>
        </div>

        <AdminLogoutConfirmationModal
          history={this.props.history}
          showModal={showModal}
          onCloseModal={() => this.onCloseModal()}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AdminNavbar);
